/* eslint-disable react/no-danger */
import React from 'react';

// Enables re-hydration of React from server side redendered HTML.
const renderInitialState = (initialState) => {
	const innerHtml = `window.INITIAL_STATE = ${JSON.stringify(initialState)}`;
	return <script dangerouslySetInnerHTML={{ __html: innerHtml }} />;
};

const Template = ({ head, content, initialState }) => (
	<html lang="en">
		<head>
			<meta charSet="utf-8" />
			<title>Manasi 7 - test title</title>
		</head>
		<body>
			<div id="content" dangerouslySetInnerHTML={{ __html: content }}>
				{initialState && renderInitialState(initialState)}
			</div>
		</body>
	</html>
);

export default Template;



// WEBPACK FOOTER //
// ./Template.jsx